<template>
  <b-card v-if="isExists" no-body class="mt-3 mb-1">
    <b-tabs pills card>
      <b-tab
        v-for="(tab, key) in tabs"
        :key="key"
        :title="tab.title"
        :active="key === log.type"
        @click="() => tabKey = key"
      >
        <component
          :is="tab.component"
          v-if="tab.component !== ''"
          :idx="idx"
          :item-id="itemId"
          :items="log.items"
          :pagination="log.pagination"
          @goToPage="(p) => goToPage(key, p)"
        />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PrimeLog from './Elements/Logs/PrimeLog.vue'
import CostLog from './Elements/Logs/CostLog'
import PrivacyLog from './Elements/Logs/PrivacyLog'
import StatusLog from './Elements/Logs/StatusLog'
import EditorialRankingLog from './Elements/Logs/EditorialRankingLog' // [ID-338]
import { mapComputedStateFields } from '~/mixins/globalForm'

export default {
  name: 'Logs',
  components: {
    PrimeLog,
    CostLog,
    PrivacyLog,
    StatusLog,
    EditorialRankingLog // [ID-338]
  },
  props: {
    itemId: {
      type: [String, Number],
      required: true
    },
    idx: {
      type: Number,
      default: -1
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      tabKey: 0
    }
  },
  computed: {
    ...mapGetters({
      getByName: 'repos/getByName'
    }),
    ...mapComputedStateFields('customerEdit', [
      'logs',
      'log'
    ]),
    tabs () {
      const items = {}
      Object.keys(this.info).filter(k => this.info[k] > 0).forEach((key) => {
        switch (key) {
          case 'hostess-cost':
            items[key] = {
              title: this.$t('fCustomer_costLog_title'),
              component: 'cost-log'
            }
            break
          case 'hostess-prime':
            items[key] = {
              title: this.$t('fCustomer_primeLog_title'),
              component: 'prime-log'
            }
            break
          case 'hostess-privacy':
            items[key] = {
              title: this.$t('fCustomer_privacyLog_title'),
              component: 'privacy-log'
            }
            break
          case 'user-club-access':
            items[key] = {
              title: this.$t('fCustomer_clubAccessLog_title'),
              component: ''
            }
            break
          case 'status':
            items[key] = {
              title: this.$t('fCustomer_statusLog_title'),
              component: 'status-log'
            }
            break
          case 'editorial-ranking': // [ID-338]
            items[key] = {
              title: this.$t('fCustomer_editorialRankingLog_title'),
              component: 'editorial-ranking-log'
            }
            break
          default:
            items[key] = key
            break
        }
      })
      return items
    },
    type () {
      return this.log.type
    },
    isExists () {
      return this.info && Object.keys(this.info).length > 0
    }
  },
  watch: {
    tabKey (type) {
      this.goToPage(type, 1)
    }
  },
  mounted () {
    const keys = Object.keys(this.tabs)
    if (keys.length > 0) {
      this.tabKey = keys[0]
    }
  },
  methods: {
    ...mapActions({
      fetchLog: 'forms/customerEdit/fetchLog'
    }),
    goToPage (type, p) {
      this.fetchLog({ itemId: this.itemId, type, page: p })
    }
  }
}
</script>

<style scoped>

</style>
